import { createSlice } from "@reduxjs/toolkit";

const CardSlice = createSlice({
  name: "cards",
  initialState: {
    cardExisted: "1",
    advisorTab: "profile",
    customerTab: "profile",
    agencyTab: "profile",
        agentTab: "profile",

  },
  reducers: {
    changeCardTrue: (state, action) => {
      state.cardExisted = action.payload; // Add document ID
    },
    changeCardFalse: (state) => {
      state.cardExisted = "1"; // Reset state to an empty array
    },
    changeAdvisorTabTrue: (state, action) => {
      state.advisorTab = action.payload; // Add document ID
    },
    changeAdvisorTabFalse: (state) => {
      state.advisorTab = "profile"; // Reset state to an empty array
    },
    changeCustomerTabTrue: (state, action) => {
      state.customerTab = action.payload; // Add document ID
    },
    changeCustomerTabFalse: (state) => {
      state.customerTab = "profile"; // Reset state to an empty array
    },
    changeBusinessTabTrue: (state, action) => {
      state.businessTab = action.payload; // Add document ID
    },
    changeBusinessTabFalse: (state) => {
      state.businessTab = "profile"; // Reset state to an empty array
    },
    changeAgentTabFalse: (state) => {
      state.agentTab = "profile"; // Reset state to an empty array
    },
    changeAgentTabTrue: (state, action) => {
      state.agentTab = action.payload; // Add document ID
    },
    changeAgencyTabTrue: (state, action) => {
      state.agencyTab = action.payload; // Add document ID
    },
    changeAgencyTabFalse: (state) => {
      state.agencyTab = "profile"; // Reset state to an empty array
    },
  },
});

export const {
  changeCardTrue,
  changeCardFalse,
  changeAdvisorTabTrue,
  changeAdvisorTabFalse,
  changeCustomerTabTrue,
  changeCustomerTabFalse,
  changeBusinessTabFalse,
  changeBusinessTabTrue,
  changeAgentTabFalse,
  changeAgentTabTrue,
  changeAgencyTabTrue,
  changeAgencyTabFalse,
} = CardSlice.actions;

export default CardSlice.reducer;
